import React from 'react';
import { IoOpenOutline } from 'react-icons/io5';

export function ButtonLink({ metadata, darkMode }) {
    if (!metadata || !metadata.url || !metadata.label) return null;

    const style = metadata.style || 'primary';

    let buttonClass = 'tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-rounded-2xl tw-font-semibold tw-text-sm tw-transition-colors tw-border-0 tw-cursor-pointer';

    if (style === 'primary') {
        buttonClass += ' tw-bg-primary tw-text-white hover:tw-bg-primary/90';
    } else if (style === 'outline') {
        buttonClass += darkMode
            ? ' tw-border tw-border-gray-600 tw-text-gray-100 hover:tw-bg-gray-700'
            : ' tw-border tw-border-gray-300 tw-text-gray-800 hover:tw-bg-gray-50';
    } else {
        buttonClass += darkMode
            ? ' tw-bg-gray-700 tw-text-white hover:tw-bg-gray-600'
            : ' tw-bg-gray-100 tw-text-gray-900 hover:tw-bg-gray-200';
    }

    return (
        <div className="tw-mt-2 tw-mb-1">
            <a
                href={metadata.url}
                target={metadata.target || '_blank'}
                rel={metadata.target === '_blank' ? 'noopener noreferrer' : undefined}
                className={buttonClass}
                style={{ textDecoration: 'none' }}
            >
                {metadata.label}
                {(metadata.target || '_blank') === '_blank' && (
                    <IoOpenOutline size={15} />
                )}
            </a>
        </div>
    );
}
